export default async (context) => {
    let el = document.getElementById('player-component__video')
    let button = document.getElementById('player-component__button')

    if(button.style.display === 'block') {
        button.style.display = 'none'
    } else {
        button.style.display = 'block'
    }


    if(button.style.display === 'none') {

        if(context.preview[0].descr.length > 0) {

            el.play()

            let text = document.getElementById('player-component__text')
            let width = text.getBoundingClientRect().width
            let time = context.preview[0].descr.length > 3 ? context.preview[0].descr.length : 3
            text.style.animationPlayState = 'running'
            text.style.color = context.textColor
            document.documentElement.style.setProperty('--textMargin', `-${width + (width / 20)}px`)
            text.style.animation = `text-rotate ${context.speedText * time}s linear`
            text.addEventListener("animationend", () => {
                el.pause()
                el.currentTime = 0
                text.style.animation = 'none'
                document.documentElement.style.setProperty('--textMargin', `calc(var(--widthVideo) + var(--widthVideo) / 2`)
                button.style.display = 'block'
            })
        } else {

            el.play()

            context.text_blur_input(context)

            el.onended = async () => {
                el.pause()
                el.currentTime = 0
                button.style.display = 'block'
            }
        }

    } else {
        el.pause()

        if(context.preview[0].descr.length > 0) {
            let text = document.getElementById('player-component__text')
            text.style.animationPlayState = 'paused'
        }
    }
}